module.exports = __webpack_public_path__ + "img/sone.0c9ad550.png";